import { withInstall } from '../_util'
import { ElTooltip } from 'element-plus'
import { cloneDeep } from 'lodash-es'

const Tooltip = cloneDeep(ElTooltip)
Tooltip.name = 'OTooltip'
Tooltip.__name = 'OTooltip'

export default withInstall<typeof Tooltip, {}>(Tooltip, {})
